import { mount } from 'svelte';
import ProrationInfo from '../src/svelte/space/membership_signups/ProrationInfo.svelte';
(() => {
  const mountElement = document.getElementById('membership-signup-proration');
  if (!mountElement) {
    return;
  }
  const previewUrl = mountElement.dataset.previewUrl || '';
  const formSelector = mountElement.dataset.formSelector;
  const form =
    (formSelector && document.querySelector<HTMLFormElement>(formSelector)) ||
    null;
  mount(ProrationInfo, {
    target: mountElement,
    props: {
      previewUrl,
      form,
    },
  });
})();
